// extracted by mini-css-extract-plugin
module.exports = {"modal":"banners_modal__HQ__D","close":"banners_close__ua2Bp"};